<span [class]="spanClass()" [attr.aria-label]="tier() + ' jewellery tier'"></span>
